import { render, staticRenderFns } from "./ShopSign.vue?vue&type=template&id=687f54f1&scoped=true&"
import script from "./ShopSign.vue?vue&type=script&lang=js&"
export * from "./ShopSign.vue?vue&type=script&lang=js&"
import style0 from "./ShopSign.vue?vue&type=style&index=0&id=687f54f1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687f54f1",
  null
  
)

export default component.exports